import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { postJSON, getCSRFHeaders } from '@folklore/fetch';
import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';
import { useFieldsComponentsManager } from '@panneau/core/contexts';

var _excluded = ["title", "endpoint", "action", "label", "icon", "template", "theme", "disabled", "outline", "onConfirmed", "fieldComponent", "className"];

// TODO: figure out what happens when an item / multiple items are selected

var propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  id: PropTypes.string,
  title: PropTypes.node,
  endpoint: PropTypes.string,
  action: PropTypes.func,
  // Promise
  label: PropTypes.string,
  template: PropTypes.shape({
    columns: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string
    }))
  }),
  icon: PropTypes.string,
  theme: PropTypes.string,
  disabled: PropTypes.bool,
  outline: PropTypes.bool,
  fieldComponent: PropTypes.string,
  onConfirmed: PropTypes.func,
  className: PropTypes.string
};
var defaultProps = {
  id: null,
  title: null,
  endpoint: '/import',
  action: null,
  label: null,
  icon: 'database',
  template: null,
  theme: 'primary',
  disabled: false,
  outline: false,
  fieldComponent: 'import',
  onConfirmed: null,
  className: null
};
var ImportAction = function ImportAction(_ref) {
  var title = _ref.title,
    endpoint = _ref.endpoint,
    action = _ref.action,
    label = _ref.label,
    icon = _ref.icon,
    template = _ref.template,
    theme = _ref.theme,
    disabled = _ref.disabled,
    outline = _ref.outline,
    onConfirmed = _ref.onConfirmed,
    fieldComponent = _ref.fieldComponent,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var FieldComponents = useFieldsComponentsManager();
  var FieldComponent = FieldComponents.getComponent(fieldComponent);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var onComplete = useCallback(function (data) {
    return (action !== null ? action(data) : postJSON(endpoint, data, {
      credentials: 'include',
      headers: getCSRFHeaders()
    })).then(function (response) {
      if (onConfirmed !== null) {
        onConfirmed(response);
      }
      setError(null);
    })["catch"](function (err) {
      var _ref2 = err || {},
        _ref2$message = _ref2.message,
        message = _ref2$message === void 0 ? null : _ref2$message;
      setError(message);
    });
  }, [endpoint, action, setError, onConfirmed]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldComponent, Object.assign({
    isModal: true,
    title: title,
    theme: theme,
    template: template,
    icon: icon,
    label: label,
    onChange: onComplete,
    disabled: disabled,
    outline: outline,
    className: className
  }, props)), error !== null ? /*#__PURE__*/React.createElement("p", {
    className: "text-danger"
  }, error) : null);
};
ImportAction.propTypes = propTypes;
ImportAction.defaultProps = defaultProps;

export { ImportAction as default };
